{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Fullscreen",
		"achievements": "Achievements",
		"reset": "Reset"
	},
	"messages": {
		"prophecy": "A bunny twitches its nose... something ancient stirs...",
		"cosmic": "The answer to life, the universe, and everything? Bunnies. Obviously.",
		"astral": "Your clicking echoes through the astral warren...",
		"speaking": "Wait... did you hear that? The thumping... it's speaking to you...",
		"ancient": "The carrots resonate with ancient power!",
		"sages": "The Elder Rabbits whisper of your potential...",
		"demons": "BEHOLD! The Carrot Demons arise from the deepest burrow!",
		"veil": "Your clicks pierce the veil between warrens!",
		"spirits": "The Bunny Spirits dance to your rhythm...",
		"council": "The Grand Warren Council has noticed your dedication",
		"primordial": "Your thumping awakens primordial bunnies!",
		"void": "The rabbit hole gazes back at you...",
		"runes": "Ancient carrot runes glow beneath the earth!",
		"beast": "THREE THREE THREE - THE NUMBER OF THE BUNNY BEAST",
		"prophets": "The Warren Prophets sing of your coming!",
		"dimensions": "Your thumps echo through every burrow in existence...",
		"portal": "Your clicks have opened a portal to the Carrot Dimension!",
		"burrow": "You've dug deeper than any rabbit before...",
		"warren": "The Great Warren recognizes your presence...",
		"sacrifice": "The ancient Bunny Gods demand MORE CARROTS",
		"thump": "The earth trembles with every thump of your foot!",
		"darkWarren": "The Dark Warren opens its gates for you...",
		"ears": "Your ears grow longer... you can hear everything now...",
		"jackpot": "JACKPOT! The Carrot Casino crowns its champion! 🥕🎰",
		"unmatched": "兔子的力量无人能及! (Your bunny power is unmatched!)",
		"carrotThrone": "The Carrot Throne materializes before you...",
		"reality": "Reality bends around your twitching whiskers!",
		"onesAlignment": "All ones align - the Warren Frequency resonates!",
		"elite": "YOU HAVE BECOME THE ELITE BUNNY MASTER 🐇",
		"power": "Your bunny power level is OVER FIFTEEN HUNDRED!",
		"devils": "The Carrot Devils bow before your floofy might",
		"lucky": "Lucky rabbit feet? You ARE the lucky rabbit",
		"dynasty": "The Bunny Dynasty recognizes your supremacy 🐰",
		"twoThousand": "Two thousand thumps of pure lagomorph power!",
		"quartet": "The prophecy of the Four Rabbits is fulfilled",
		"transcend": "Your hopping transcends mortal understanding",
		"constellation": "The Bunny Constellation aligns in your honor 🌙",
		"destiny": "THREE THOUSAND THUMPS OF DESTINY",
		"triforce": "The Triple Carrot Triforce awakens!",
		"fortune": "Fortune favors the persistent bunny",
		"newDimensions": "Your bunny energy reaches dimensions unknown to mortals",
		"quartet2": "The Quadruple Warren Quartet harmonizes",
		"threshold": "Standing at the threshold of carrot divinity...",
		"ultimate": "FIVE THOUSAND THUMPS OF ULTIMATE BUNNY POWER! 🐰⚡",
		"force": "The Five Pawed Bunny Force is yours to command",
		"underworld": "The Carrot Underworld crowns you their Fluffy Overlord",
		"moonSummon": "The Moon Rabbit hears your call across the void...",
		"maxJackpot": "MAXIMUM CARROT JACKPOT! THE WARREN OVERFLOWS! 🥕🥕🥕",
		"infinite": "无限兔子力量! (INFINITE BUNNY POWER!)",
		"edgeOfForever": "You stand at the edge of forever... ears twitching...",
		"godhood": "YOU HAVE ASCENDED TO BUNNY GODHOOD 🐰👑",
		"beyondTheVeil": "Beyond the veil, all warrens become one...",
		"sequence": "1-2-3-4-5... The Sacred Hop Sequence is complete!",
		"hyperElite": "HYPER ELITE BUNNY STATUS UNLOCKED 🐇🐇🐇",
		"eventHorizon": "Past the event horizon of the Cosmic Rabbit Hole...",
		"matrixAwakens": "The Warren Matrix glitches... you see the carrots behind reality",
		"luckyForever": "Every paw, every hop, every twitch... blessed forever",
		"twentyK": "TWENTY THOUSAND. You are no longer a bunny. You are THE bunny.",
		"singularity": "The Bunny Singularity. All rabbits are you. You are all rabbits.",
		"tripleAscension": "The Triple Ascension of the Cosmic Hare!",
		"ultimateAnswer": "42,000 - The Ultimate Answer was carrots all along",
		"eternity": "♾️ THE ETERNAL WARREN HAS NO END. NEITHER DO YOU. ♾️"
	},
	"achievements": {
		"title": "Achievements",
		"noAchievements": "No achievements earned yet. Keep clicking!",
		"unlocked": "Achievement Unlocked: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Beginner Bunny",
		"carrotSnatcher": "🥕 Vegetable Bandit",
		"bunnyBerserker": "😡 Rabid Rampage",
		"hopPunk": "🎸 Anarchist Cottontail",
		"bunnyNinja": "🥷 Silent but Deadly Floof",
		"expert": "🌟 Expert Hopper",
		"master": "👑 Carrot King",
		"carrotpocalypse": "🥕 Destroyer of Vegetable Gardens",
		"bunnyOverlord": "😈 Supreme Leader of the Warren",
		"chaosHare": "🌪️ Agent of Bunny Chaos",
		"carrotCultist": "⛪ High Priest of the Carrot Cult",
		"bunnyberryPie": "🥧 Hallucinogenic Pie Master",
		"rabbitHole": "🕳️ Quantum Tunnel Digger",
		"moonRabbit": "🌙 Lunar Jade Pounder",
		"bunnyDoom": "💀 Harbinger of the Bunpocalypse",
		"carrotNuke": "☢️ Thermonuclear Carrot Wielder",
		"bunnyMatrix": "🤖 Glitch in the Warren Matrix",
		"cosmicHare": "🌌 The Cosmic Hare Awakens",
		"warrenSingularity": "🕳️ Warren Singularity Achieved",
		"eternalBunny": "♾️ The Eternal Bunny"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Bonus Carrots!",
		"clickStreak": "🔥 {{count}} Thump Streak!",
		"fire": "🔥 Fire Power Activated!"
	},
	"table": {
		"achievement": "Achievement",
		"progress": "Progress"
	},
	"reset": {
		"confirm": "Are you sure you want to reset all progress? This cannot be undone."
	}
}
